import { listPageDefaultData } from "dependencies/emptyLayout/index.js"
export default {
  name: "列表页自由布局组件",
  id: "",
  type: "listPageComponent",
  children: listPageDefaultData
}
